import { Children } from "react";

import './recycling.css';

export default function RecyclingModal({isOpen,setOpen,lang,children}) {
  if( isOpen ) {
    return (
      <div className="recycling-container">
        <div className="recycling-recycling">
          <img
            alt="image273979"
            src="/external/back-btn.svg"
            className="recycling-image27"
            onClick={() => setOpen(false)}
          />
          <span className="recycling-text1 MOBILEBODYCOPY1">
            <span>How to recycle HUGO BOSS?</span>
          </span>
          <img
            alt="image335186"
            src={lang == 'FRA' ? "/external/FR_recycling_graphic.svg" : "/external/ES_recycling.svg" }
            className="recycling-image33"
          />
        </div>
      </div>
    );
  }
  return( children );
};